import { Link, Text } from '@billy/design-system'
import { PropsWithChildren, ReactElement } from 'react'

interface ActionTextProps extends PropsWithChildren {
  isDisabled?: boolean
  onClick: () => void
}

export const ActionText = ({ children, isDisabled = false, onClick }: ActionTextProps): ReactElement => (
  <Text as="span" nowrap variant="bodySM">
    <Link disabled={isDisabled} onClick={onClick}>
      {children}
    </Link>
  </Text>
)
